import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux-store/store';

const selectProjectPhaseProfileMetadata = (state: RootState) =>
  state.projectPhaseProfileMetadata.collapsedState;

export const selectCollapsedStateByProjectId = (projectId: number) =>
  createSelector(
    selectProjectPhaseProfileMetadata,
    (collapsedState) => collapsedState[projectId] || {}
  );
export const makeSelectPhaseCollapsed = (projectId: number, phaseId: number) =>
  createSelector(
    selectProjectPhaseProfileMetadata,
    (collapsedState) => collapsedState[projectId]?.[phaseId] ?? false
  );
export const accountStepperSelector = (state: RootState) => state.accountStepper;
export const authSelector = (state: RootState) => state.auth;
export const queryArgsSelector = (state: RootState) => state.queryArgs;
export const queryCommentArgsSelector = (state: RootState) => state.queryArgs.comments;
export const isActivityFeedSearchActive = (
  state: RootState,
  placeOfUse: 'post_modal' | 'activity_feed'
) => {
  return !!state.queryArgs?.posts?.search?.trim() && placeOfUse === 'activity_feed';
};
export const newCommentsSelector = (state: RootState) => state.newComments;
export const billingSelector = (state: RootState) => state.billing;
export const replyToPostSelector = (state: RootState) => state.replyToPost;
export const editorHeightSelector = (state: RootState) => state.editorHeight;
export const sidePanelSelector = (state: RootState) => state.sidePanel;
export const manageGanttSelector = (state: RootState) => state.manageGantt;
export const manageCalendarSelector = (state: RootState) => state.calendarView;
export const allProjectsSelector = (state: RootState) => state.allProjects;
export const fromMobileSelector = (state: RootState) => state.fromMobile;
export const fileCabinetSelector = (state: RootState) => state.fileCabinet;
export const scheduleModalsSelector = (state: RootState) => state.scheduleModals;
export const selectAllProjectsCalendarMode = (state: RootState) =>
  state.calendarView.allProjectsCalendarMode;
export const selectCalendarMode = (state: RootState) => state.calendarView.calendarMode;
export const selectedSelectionsSelector = (state: RootState) => state.selectedSelections;
export const selectedTemplateSelectionsSelector = (state: RootState) =>
  state.selectedTemplateSelections;
export const selectedTemplateSelectionsCountSelector = createSelector(
  selectedTemplateSelectionsSelector,
  ({ selectedTemplateSelections }) => {
    return Object.values(selectedTemplateSelections).flat().length;
  }
);
export const selectedTemplateSelectionIdsSelector = createSelector(
  selectedTemplateSelectionsSelector,
  ({ selectedTemplateSelections }) => {
    return Object.values(selectedTemplateSelections)
      .flat()
      .map(({ id }) => id);
  }
);
export const costCodeTemplateSelector = (state: RootState) => state.costCodeTemplate;
export const checklistSelector = (state: RootState) => state.checklist;
export const getIsPostEdit = (
  state: RootState,
  id: number,
  placeOfUse: 'post_modal' | 'activity_feed' | null
) => {
  return (
    state.postEditState.postToEditId === id &&
    state.postEditState.postToEditPlaceOfUse === placeOfUse
  );
};
export const getUnreadDraftsCount = (state: RootState) => state.draft.unreadDraftsIds.length;
export const getEditablePostDraft = (state: RootState) => state.draft.editablePostDraft;
export const getEditableCommentDraft = (state: RootState) => state.draft.editableCommentDraft;
export const getActivePostDraftId = (state: RootState) => state.draft.activePostDraftId;
export const getDrafts = (state: RootState) => state.draft.drafts;
